export default __webpack_public_path__ + "static/media/logoDesktop.159c356f.svg";